import React from 'react';
import classNames from 'classnames';
import styles from './ProductMenuCover.module.less';
import { Icon } from '../Icon';
import Transition from '../Transition';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectIsMeasurementsActive,
  selectIsWallResizerActive,
} from '../../state/scene/sceneSelectors';
import { actionSetWallResizerInactive } from '../../state/scene/sceneActions';
import { actionHideMeasurements } from '../../state/scene';

export interface Props {
  trashcan: boolean;
  show: boolean;
  enlarge: boolean;
}

const ProductMenuCover = React.forwardRef<HTMLDivElement, Props>(
  ({ trashcan, show, enlarge }, ref) => {
    ProductMenuCover.displayName = 'ProductMenuCover';
    const wallResizerActive = useSelector(selectIsWallResizerActive);
    const measurementsActive = useSelector(selectIsMeasurementsActive);
    const dispatch = useDispatch();
    const setWallResizerInactive = () =>
      dispatch(actionSetWallResizerInactive({}));
    const hideMeasurements = () => dispatch(actionHideMeasurements({}));

    const onClick = () => {
      wallResizerActive && setWallResizerInactive();
      measurementsActive && hideMeasurements();
    };

    return (
      <div
        className={classNames(
          styles.trashCan,
          show && styles.visible,
          enlarge && styles.large
        )}
        onClick={onClick}
        ref={ref}
      >
        <Transition in={trashcan}>
          <div className={styles.icon}>
            <Icon className={styles.trashCanIcon} iconName="TrashCanIcon" />
          </div>
        </Transition>
      </div>
    );
  }
);

export default ProductMenuCover;
